import { Close } from '@mui/icons-material';
import { closeSnackbar, enqueueSnackbar } from 'notistack';

export const SnackBar = (
  variant: 'error' | 'success' | 'info' | 'warning',
  message: string
  // onView?: () => void
) => {
  enqueueSnackbar(message, {
    variant,
      action: (snackbarId) => (
        <Close onClick={() => closeSnackbar(snackbarId)} />
      ),
  });
};
